import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AdminLayout from "../../layouts/Admin";
import AdminMenu from "../../adminPages/adminMenu";
import Candidates from "../../candidates";
import ManageClients from "../../clients/manageClients/manageClients";
import GenericAccountDetails from "../../genericAccounts/genericAccountDetailScreen/accountDetailsScreen";
import UserDetails from "../../users/userDetails";
import CandidateProfile from "../../candidate/ProfileDetails";
import AddManageGenericAccount from "../../genericAccounts/addManageGenericAccounts/addManageGA";
import ClientsProfile from "../../clients/manageClients/clientProfile";
import EditExistingClients from "../../clients/manageClients/editExistingClient";
import CreateNewUser from "../../users/createNewUser";

import EditSystemMessage from "../../systemMessages/editSystemMessage";
import SearchSystemMessage from "../../systemMessages/searchSystemMessage";

import HomeAccountTeamMembers from "../components/rtiSetUp/accountTeamMembers/HomeAccountTeamMembers";
import CreateAccountTeamMembers from "../components/rtiSetUp/accountTeamMembers/createAccountTeamMembers/CreateAccountTeamMembers";
import EditAccountTeamMembersHome from "../components/rtiSetUp/accountTeamMembers/editAccountTeamMenber/EditAccountTeamMembersHome";

import ClientAccountHome from "../components/rtiSetUp/manageClientAccount/clientAccount/ClientAccountHome";
import CreateClientAccount from "../components/rtiSetUp/manageClientAccount/clientAccount/createClientAccount/CreateClientAccount";
import ClientSubAccountHome from "../components/rtiSetUp/manageClientAccount/clientSubAccount/ClientSubAccountHome";
import CreateClientSubAccount from "../components/rtiSetUp/manageClientAccount/clientSubAccount/createClientSubAccount/CreateClientSubAccount";
import EditClientSubAccountHome from "../components/rtiSetUp/manageClientAccount/clientSubAccount/editClientSubAccount/EditClientSubAccountHome";
import ClientSpecificReportHome from "../components/rtiSetUp/reportAndResources/clientSpecificReports/ClientSpecificReportHome";
import ThoughtLeadershipResourcesHome from "../components/rtiSetUp/reportAndResources/thoughtLeadershipResources/ThoughtLeadershipResourcesHome";
import CreateClientSpecificReport from "../components/rtiSetUp/reportAndResources/clientSpecificReports/createClientSpecificReport/CreateClientSpecificReport";

import MeetingRequestHome from "../components/rtiSetUp/meetingRequests/MeetingRequestHome";
import AdminMessageHome from "../components/rtiSetUp/adminMessages/AdminMessageHome";
import CreateAdminMessage from "../components/rtiSetUp/adminMessages/createAdminMessage/CreateAdminMessage";
import EditAdminMessageHome from "../components/rtiSetUp/adminMessages/editAdminMessage/EditAdminMessageHome";

import ClientUserHome from "../components/rtiSetUp/clientUser/ClientUserHome";
import CreateClientUser from "../components/rtiSetUp/clientUser/createClientUser/CreateClientUser";
import EditClientUserHome from "../components/rtiSetUp/clientUser/editClientUser/EditClientUserHome";
import EditMeetingRequestHome from "../components/rtiSetUp/meetingRequests/editMeetingRequests/EditMeetingRequestHome";
import EditClientAccountHome from "../components/rtiSetUp/manageClientAccount/clientAccount/editClientAccount/EditClientAccountHome";
import AssignReferralReqHome from "../components/rtiSetUp/referrals/assignReferralReq/AssignReferralReqHome";
import ManageReferralReqHome from "../components/rtiSetUp/referrals/manageReferralReq/ManageReferralReqHome";

import EditAssignReferralReqHome from "../components/rtiSetUp/referrals/assignReferralReq/editAssignReferralReq/EditAssignReferralsHome";
import EditManageReferralReqHome from "../components/rtiSetUp/referrals/manageReferralReq/editManageReferralReq/EditManageReferralReqHome";
import EditClientSpecificReportHome from "../components/rtiSetUp/reportAndResources/clientSpecificReports/editClientSpecificReport/EditClientSpecificReportHome";
import EditThoughtLeadershipResourcesHome from "../components/rtiSetUp/reportAndResources/thoughtLeadershipResources/editThoughtLeadershipResources/EditThoughtLeadershipResourcesHome";
import CommonButtonHeader from "../components/rtiSetUp/manageClientAccount/CommonButtonHeader";
import ReportAndResourcesHeader from "../components/rtiSetUp/reportAndResources/ReportAndResourcesHeader";
import ReferralHeader from "../components/rtiSetUp/referrals/ReferralHeader";
import NotFoundComp from "./NotFoundComp";
import ProtectedClientPortalSettingRoutes from "./ProtectedClientPortalSettingRoutes";
import ProtectedGetUserDetailsRoutes from "./ProtectedGetUserDetailsRoutes";
import { getAccessTypes } from "../hooksAndFunctions/functions/getAccessTypes";
import ProgrammeDescriptorHeader from "../components/rtiSetUp/programmeDescriptor/ProgrammeDescriptorHeader";
import EditProgrammeDescriptorHome from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/editProgrammeDescriptor/EditProgrammeDescriptorHome";
import ProgrammeDescriptorHome from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/ProgrammeDescriptorHome";
import CreateProgrammeDescriptor from "../components/rtiSetUp/programmeDescriptor/manageProgrammeDescriptor/createProgrammeDescriptor/CreateProgrammeDescriptor";
import ClientAccPDHome from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/ClientAccPDHome";
import EditClientAccPDHome from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/editClientAccPD/EditClientAccPDHome";
import CreateClientAccPD from "../components/rtiSetUp/programmeDescriptor/clientAccProgrammeDescriptor/createClientAccPD/CreateClientAccPD";
//import AdminUserHome from "../components/rtiSetUp/adminUsers/AdminUserHome";
//import CreateAdminUser from "../components/rtiSetUp/adminUsers/createAdminUser/CreateAdminUser";
//import EditAdminUserHome from "../components/rtiSetUp/adminUsers/editAdminUser/EditAdminUserHome";
import ResourceFolderStructureHome from "../components/rtiSetUp/programmeDescriptor/resourceFolderStructure/ResourceFolderStructureHome";
import UploadAndCreateCustomPD from "../components/rtiSetUp/programmeDescriptor/uploadAndCreateCustomPD/UploadAndCreateCustomPD";
import ClientSearch from "../../pages/clientSearch/ClientSearch";
import CreateClient from "../../pages/createClient/CreateClient";
import ViewClient from "../../pages/viewClient/ViewClient";
import ProgramTemplateSearch from "../../pages/programTemplateSearch/ProgramTemplateSearch";
import CreateProgramTemplate from "../../pages/createProgramTemplate/CreateProgramTemplate";
import ViewProgramTemplate from "../../pages/viewProgramTemplate/ViewProgramTemplate";
import EditProgramTemplate from "../../pages/editProgramTemplate/EditProgramTemplate";
import CreateProgram from "../../pages/createProgram/CreateProgram";
import CreateNISParticipant from "../../pages/createNISParticipant/CreateNISParticipant";
import ViewNISParticipant from "../../pages/viewNISParticipant/ViewNISParticipant";
import EditNISParticipant from "../../pages/editNISParticipant/EditNISParticipant";
import ProgramSearch from "../../pages/programSearch/ProgramSearch";
import ViewProgram from "../../pages/viewProgram/ViewProgram";
import EditProgram from "../../pages/editProgram/EditProgram";
import CreateBulkActivity from "../../pages/createBulkActivity/CreateBulkActivity";
import ManageBulkProcess from "../../pages/manageBulkProcess/ManageBulkProcess";
import CreateBulkTransfer from "../../pages/createBulkTransfer/CreateBulkTransfer";
import BulkCreateProgram from "../../pages/bulkCreateProgram/BulkCreateProgram";
import BulkEditProgram from "../../pages/bulkEditProgram/BulkEditProgram";
import CreateGenericAccount from "../../pages/genericAccounts/createGenericAccount/CreateGenericAccount";
import { EditGenericAccountTab } from "../../pages/genericAccounts/editGenericAccountTab/EditGenericAccountTab";
import GenericAccountsSearch from "../../pages/genericAccounts/genericAccountsSearch/GenericAccountsSearch";
import ViewGenericAccount from "../../pages/genericAccounts/viewGenericAccount/ViewGenericAccount";
import { EditParticipant } from "../../pages/participants/editParticipant/EditParticipant";
import { PAGE_URLS } from "../../helpers/constants";
import ViewParticipant from "../../pages/participants/viewParticipant/ViewParticipant";
import MdmActivitySearch from "../../pages/mdmActivitySearch/MdmActivitySearch";
import MdmOfficeSearch from "../../pages/mdmOfficeSearch/MdmOfficeSearch";
import { SearchReport } from "../../pages/reports/ReportSearch";
import { ParticipantsMain } from "../../pages/coachPortal/participantsMain/ParticipantsMain";
import { CPDashboardMain } from "../../pages/coachPortal/cpDashboard/CPDashboardMain";
import { UsersSearch } from "../../pages/usersSearch/UsersSearch";
import { SystemMessageSearch } from "../../pages/systemMessageSearch/SystemMessageSearch";
import { CPViewParticipantMain } from "../../pages/coachPortal/cpViewParticipantMain/CPViewParticipantMain";
import { CPEditParticipantMain } from "../../pages/coachPortal/cpEditParticipantMain/CPEditParticipantMain";
import BulkManageProgram from "../../pages/bulkManageProgram/BulkManageProgram";
import PermissionProtectedRoute from "./PermissionProtectedRoute";
import ProjectSearch from "../../pages/projectSearch/ProjectSearch";
import CreateProject from "../../pages/createProject/CreateProject";
import EditProject from "../../pages/editProject/EditProject";
import ViewProject from "../../pages/viewProject/ViewProject";

const RoutesComp = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const { clientPortalAdminType,
  } = getAccessTypes()

  const {
    hasA2Access,
    hasA3Access
  } = clientPortalAdminType

  // console.log("access:", clientPortalAdminType)

  return (
    <Routes>
      {/* <Route element={<AuthProtectedRoute />} > */}
      <Route element={<ProtectedGetUserDetailsRoutes />}>
        <Route path="/" element={<AdminLayout />}>
          <Route path="/" element={<AdminMenu />} />
          <Route
            path={PAGE_URLS.DASHBOARD}
            element={
              <PermissionProtectedRoute>
                <AdminMenu />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.SEARCH_CLIENT}
            element={
              <PermissionProtectedRoute>
                <ClientSearch />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.CREATE_CLIENT}
            element={
              <PermissionProtectedRoute>
                <CreateClient key={"/create-client"} isEdit={false} />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.EDIT_CLIENT}
            element={
              <PermissionProtectedRoute>
                <CreateClient key={"/edit-client"} isEdit={true} />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.VIEW_CLIENT}/:id`}
            element={
              <PermissionProtectedRoute>
                <ViewClient />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.SEARCH_PROJECT}
            element={
              <PermissionProtectedRoute>
                <ProjectSearch />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.CREATE_PROJECT}
            element={
              <PermissionProtectedRoute>
                <CreateProject />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.EDIT_PROJECT}/:id`}
            element={
              <PermissionProtectedRoute>
                <EditProject />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.VIEW_PROJECT}/:id`}
            element={
              <PermissionProtectedRoute>
                <ViewProject />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.PROGRAM_TEMPLATE}
            element={
              <PermissionProtectedRoute>
                <ProgramTemplateSearch />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.CREATE_PROGRAM_TEMPLATE}
            element={
              <PermissionProtectedRoute>
                <CreateProgramTemplate />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.VIEW_PROGRAM_TEMPLATE}/:id`}
            element={
              <PermissionProtectedRoute>
                <ViewProgramTemplate />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.EDIT_PROGRAM_TEMPLATE}/:id`}
            element={
              <PermissionProtectedRoute>
                <EditProgramTemplate />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.VIEW_PROGRAM}/:id`}
            element={
              <PermissionProtectedRoute>
                <ViewProgram />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.CREATE_PROGRAM}
            element={
              <PermissionProtectedRoute>
                <CreateProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.CREATE_NIS_PARTICIPANT}
            element={
              <PermissionProtectedRoute>
                <CreateNISParticipant />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.VIEW_NIS_PARTICIPANT}/:id`}
            element={
              <PermissionProtectedRoute>
                <ViewNISParticipant />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.EDIT_NIS_PARTICIPANT}/:id`}
            element={
              <PermissionProtectedRoute>
                <EditNISParticipant />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.SEARCH_PROGRAM}
            element={
              <PermissionProtectedRoute>
                <ProgramSearch />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.EDIT_PROGRAM}/:id`}
            element={
              <PermissionProtectedRoute>
                <EditProgram />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.CREATE_BULK_ACTIVITY}
            element={
              <PermissionProtectedRoute>
                <CreateBulkActivity />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.MANAGE_BULK_PROCESS}
            element={
              <PermissionProtectedRoute>
                <ManageBulkProcess />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.CREATE_BULK_TRANSFER}
            element={
              <PermissionProtectedRoute>
                <CreateBulkTransfer />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_CREATE_PROGRAM}
            element={
              <PermissionProtectedRoute>
                <BulkCreateProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_EDIT_PROGRAM}
            element={
              <PermissionProtectedRoute>
                <BulkEditProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_CREATE_PROGRAM_DETAILS}
            element={
              <PermissionProtectedRoute>
                <BulkManageProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_EDIT_PROGRAM_DETAILS}
            element={
              <PermissionProtectedRoute>
                <BulkManageProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_INSERT_ACTIVITY_DETAILS}
            element={
              <PermissionProtectedRoute>
                <BulkManageProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.BULK_TRANSFER_PARTICIPANTS_DETAILS}
            element={
              <PermissionProtectedRoute>
                <BulkManageProgram />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.MDM_ACTIVITY}
            element={
              <PermissionProtectedRoute>
                <MdmActivitySearch />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.SEARCH_USERS}
            element={
              <PermissionProtectedRoute>
                <UsersSearch />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.SYSTEM_MESSAGES}
            element={
              <PermissionProtectedRoute>
                <SystemMessageSearch />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.MDM_OFFICE}
            element={
              <PermissionProtectedRoute>
                <MdmOfficeSearch />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.GENERIC_ACCOUNTS_SEARCH}
            element={
              <PermissionProtectedRoute>
                <GenericAccountsSearch />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.CREATE_GENERIC_ACCOUNTS}
            key={"/create-generic-account"}
            element={
              <PermissionProtectedRoute>
                <CreateGenericAccount />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.EDIT_GENERIC_ACCOUNTS}
            key={"/edit-generic-account"}
            element={
              <PermissionProtectedRoute>
                <EditGenericAccountTab />
              </PermissionProtectedRoute>
            }
          />

          <Route
            path={PAGE_URLS.VIEW_GENERIC_ACCOUNT}
            element={
              <PermissionProtectedRoute>
                <ViewGenericAccount />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.VIEW_PARTICIPANT}
            element={
              // <PermissionProtectedRoute>
              <ViewParticipant />
              // </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.EDIT_PARTICIPANT}
            element={
              // <PermissionProtectedRoute>
              <EditParticipant />
              // </PermissionProtectedRoute>
            }
          />

          <Route path="/candidates" element={<Candidates />} />
          {/* <Route path="/users" element={<UserAccounts />} /> */}

          {/* <Route path="/users" element={<AdminUserHome />} /> */}

          <Route path="/clients" element={<ManageClients />} />
          <Route
            path="/generic-accounts-details"
            element={<GenericAccountDetails />}
          />
          <Route path="/user-details" element={<UserDetails />} />
          <Route path="/candidateProfile" element={<CandidateProfile />} />
          <Route
            path="/add-manage-generic-accounts"
            element={<AddManageGenericAccount />}
          />
          <Route path="/clients-profile" element={<ClientsProfile />} />
          <Route
            path="/edit-existing-clients"
            element={<EditExistingClients />}
          />
          <Route path="/createNewUser" element={<CreateNewUser />} />

          <Route path="/systemMessage">
            <Route path="search" element={<SearchSystemMessage />} />
            <Route path="edit" element={<EditSystemMessage />} />
          </Route>

          {/** client portal setting routes */}
          <Route element={<ProtectedClientPortalSettingRoutes />}>
            <Route path="/client_portal_setup">
              {/**All Accounts */}
              <Route
                path="accounts"
                element={
                  <PermissionProtectedRoute>
                    <CommonButtonHeader />
                  </PermissionProtectedRoute>
                }
              >
                {/** Allow A2 access change */}
                {/* <Route index element={!!hasA2Access ? <ClientSubAccountHome /> : <ClientAccountHome />} /> */}
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <ClientAccountHome />
                    </PermissionProtectedRoute>
                  }
                />
                {/**client account */}
                <Route path="client_acc">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ClientAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ClientAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="create"
                    element={
                      <PermissionProtectedRoute>
                        <CreateClientAccount />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:id"
                    element={
                      <PermissionProtectedRoute>
                        <EditClientAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>

                {/**sub client account group */}
                <Route path="client_sub_acc">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ClientSubAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ClientSubAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="create"
                    element={
                      <PermissionProtectedRoute>
                        <CreateClientSubAccount />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:id"
                    element={
                      <PermissionProtectedRoute>
                        <EditClientSubAccountHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>
              </Route>

              {/**reports and resources */}
              <Route
                path="reports"
                element={
                  <PermissionProtectedRoute>
                    <ReportAndResourcesHeader />
                  </PermissionProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <ClientSpecificReportHome />
                    </PermissionProtectedRoute>
                  }
                />
                {/**client_specific_report */}
                <Route path="client_specific_report">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ClientSpecificReportHome />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ClientSpecificReportHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="create"
                    element={
                      <PermissionProtectedRoute>
                        <CreateClientSpecificReport />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:id"
                    element={
                      <PermissionProtectedRoute>
                        <EditClientSpecificReportHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>

                {/**thought_leadership_resources */}
                <Route path="thought_leadership_resources">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ThoughtLeadershipResourcesHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ThoughtLeadershipResourcesHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:sitecoreId"
                    element={
                      <PermissionProtectedRoute>
                        <EditThoughtLeadershipResourcesHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>
              </Route>

              {/**programme descriptors */}
              <Route
                path="programme_descriptor"
                element={
                  <PermissionProtectedRoute>
                    <ProgrammeDescriptorHeader />
                  </PermissionProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <ClientAccPDHome />
                    </PermissionProtectedRoute>
                  }
                />

                {/**client account programme descriptors */}
                <Route path="client_acc_pd">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ClientAccPDHome />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ClientAccPDHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="create"
                    element={
                      <PermissionProtectedRoute>
                        <CreateClientAccPD />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:id"
                    element={
                      <PermissionProtectedRoute>
                        <EditClientAccPDHome />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="addCustomResource/:clientAccountId"
                    element={
                      <PermissionProtectedRoute>
                        <UploadAndCreateCustomPD />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="folder/view/:id"
                    element={
                      <PermissionProtectedRoute>
                        <ResourceFolderStructureHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>

                {/**manage programme descriptors */}
                <Route path="manage_acc_pd">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ProgrammeDescriptorHome />
                      </PermissionProtectedRoute>
                    }
                  />

                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ProgrammeDescriptorHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="create"
                    element={
                      <PermissionProtectedRoute>
                        <CreateProgrammeDescriptor />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:id"
                    element={
                      <PermissionProtectedRoute>
                        <EditProgrammeDescriptorHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="recycle"
                    element={
                      <PermissionProtectedRoute>
                        <ProgrammeDescriptorHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>
              </Route>

              {/**referrals */}
              <Route
                path="referrals"
                element={
                  <PermissionProtectedRoute>
                    <ReferralHeader />
                  </PermissionProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    !!hasA2Access || hasA3Access ? (
                      <PermissionProtectedRoute>
                        <ManageReferralReqHome />
                      </PermissionProtectedRoute>
                    ) : (
                      <PermissionProtectedRoute>
                        <AssignReferralReqHome />
                      </PermissionProtectedRoute>
                    )
                  }
                />
                {/**assign referral requests */}
                <Route path="assign_referral_req">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <AssignReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <AssignReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:Id"
                    element={
                      <PermissionProtectedRoute>
                        <EditAssignReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>

                {/**manage referral requests */}
                <Route path="manage_referral_req">
                  <Route
                    index
                    element={
                      <PermissionProtectedRoute>
                        <ManageReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="view"
                    element={
                      <PermissionProtectedRoute>
                        <ManageReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                  <Route
                    path="edit/:Id"
                    element={
                      <PermissionProtectedRoute>
                        <EditManageReferralReqHome />
                      </PermissionProtectedRoute>
                    }
                  />
                </Route>
              </Route>

              {/**account team member */}
              <Route path="acc_team">
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <HomeAccountTeamMembers />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="view"
                  element={
                    <PermissionProtectedRoute>
                      <HomeAccountTeamMembers />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="create"
                  element={
                    <PermissionProtectedRoute>
                      <CreateAccountTeamMembers />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="edit/:Id"
                  element={
                    <PermissionProtectedRoute>
                      <EditAccountTeamMembersHome />
                    </PermissionProtectedRoute>
                  }
                />
              </Route>

              {/**meeting requests */}
              <Route path="meeting_requests">
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <MeetingRequestHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="view"
                  element={
                    <PermissionProtectedRoute>
                      <MeetingRequestHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="edit/:Id"
                  element={
                    <PermissionProtectedRoute>
                      <EditMeetingRequestHome />
                    </PermissionProtectedRoute>
                  }
                />
              </Route>

              {/**admin messages */}
              <Route path="admin_messages">
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <AdminMessageHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="view"
                  element={
                    <PermissionProtectedRoute>
                      <AdminMessageHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="create"
                  element={
                    <PermissionProtectedRoute>
                      <CreateAdminMessage />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="edit/:Id"
                  element={
                    <PermissionProtectedRoute>
                      <EditAdminMessageHome />
                    </PermissionProtectedRoute>
                  }
                />
              </Route>

              {/**client users */}
              <Route path="client_users">
                <Route
                  index
                  element={
                    <PermissionProtectedRoute>
                      <ClientUserHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="view"
                  element={
                    <PermissionProtectedRoute>
                      <ClientUserHome />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="create"
                  element={
                    <PermissionProtectedRoute>
                      <CreateClientUser />
                    </PermissionProtectedRoute>
                  }
                />
                <Route
                  path="edit/:Id"
                  element={
                    <PermissionProtectedRoute>
                      <EditClientUserHome />
                    </PermissionProtectedRoute>
                  }
                />
              </Route>
            </Route>
          </Route>
          <Route
            path={PAGE_URLS.REPORTS}
            element={
              <PermissionProtectedRoute>
                <SearchReport />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.COACH_PORTAL_DASHBOARD}
            element={
              <PermissionProtectedRoute>
                <CPDashboardMain />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={PAGE_URLS.COACH_PORTAL_SEARCH_PARTICIPANTS}
            element={
              <PermissionProtectedRoute>
                <ParticipantsMain />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.COACH_PORTAL_VIEW_PARTICIPANT}/:id`}
            element={
              <PermissionProtectedRoute>
                <CPViewParticipantMain />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path={`${PAGE_URLS.COACH_PORTAL_EDIT_PARTICIPANT}/:id`}
            element={
              <PermissionProtectedRoute>
                <CPEditParticipantMain />
              </PermissionProtectedRoute>
            }
          />
        </Route>

        <Route path="*" element={<NotFoundComp />} />
      </Route>
      {/* </Route> */}
    </Routes>
  );
};
export default RoutesComp;
